import { Control } from "react-hook-form";
import { useIntl } from "react-intl";
import { KeyValue } from "../../../../models/key-value";
import { SettingsInfoFormInputs } from "../../../../models/settings.interface";
import {
  UserDetailsFormInputs,
  UserTitle,
} from "../../../../models/users.interface";
import SelectFormInput from "../../../Shared/SelectInput/SelectFormInput";

type FormInputs = UserDetailsFormInputs | SettingsInfoFormInputs;
type TitleSelectFormInputProps = {
  control: Control<FormInputs, object>;
  required?: boolean;
  disabled?: boolean;
  isInvalid?: boolean;
};

const titles: KeyValue<string>[] = Object.keys(UserTitle).map((key) => ({
  key: UserTitle[key as keyof typeof UserTitle],
  value: UserTitle[key as keyof typeof UserTitle] || "None",
}));

const TitleSelectFormInput = ({
  isInvalid,
  disabled,
  control,
  required = false,
}: TitleSelectFormInputProps) => {
  const intl = useIntl();

  const placeholder = intl.messages[
    "MANAGEMENT.USER_DETAILS.SELECT_TITLE"
  ] as string;

  return (
    <SelectFormInput<FormInputs>
      name={"title"}
      control={control}
      rules={{
        required: required,
      }}
      input={{
        items: titles,
        disabled: disabled,
        isInvalid: isInvalid,
        placeholder: placeholder,
      }}
    />
  );
};
export default TitleSelectFormInput;
